import React from 'react';

import i18n from '@yandex-int/i18n';
import { routes } from 'client/lib/routes';
import * as keyset from 'i18n/ErrorBoundary';
import block from 'propmods';

import './ErrorBoundary.scss';

const t = i18n(keyset);

const b = block('ErrorBoundary');

interface ErrorBoundaryProps {
    children?: React.ReactNode;
    withHomepageLink?: boolean;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_error: unknown) {
        return { hasError: true };
    }

    componentDidCatch(_error: unknown, info: unknown) {
        console.warn('@ErrorBoundary catch error ', info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div {...b('container')}>
                    <div>{t('something-went-wrong')}</div>
                    {this.props.withHomepageLink && (
                        <a {...b('link')} href={routes.app.root}>
                            {t('main-page')}
                        </a>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}
